/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Was_CompareInputs */

const en_was_compare = /** @type {(inputs: Was_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was (Compare)`)
};

const es_was_compare = /** @type {(inputs: Was_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes (Comparación)`)
};

const fr_was_compare = /** @type {(inputs: Was_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancien prix (Comparaison)`)
};

const de_was_compare = /** @type {(inputs: Was_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`War (Vergleichspreis)`)
};

const ja_was_compare = /** @type {(inputs: Was_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以前の価格 (比較用)`)
};

const zh_was_compare = /** @type {(inputs: Was_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原价 (用于对比)`)
};

const ar_was_compare = /** @type {(inputs: Was_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السعر السابق (للمقارنة)`)
};

const id_was_compare = /** @type {(inputs: Was_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga Sebelumnya (Bandingkan)`)
};

const it_was_compare = /** @type {(inputs: Was_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prima (Per confronto)`)
};

const ru_was_compare = /** @type {(inputs: Was_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Было (Сравнение)`)
};

const pt_was_compare = /** @type {(inputs: Was_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes (Comparação)`)
};

const ko_was_compare = /** @type {(inputs: Was_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이전 가격 (비교용)`)
};

/**
* | output |
* | --- |
* | "Was (Compare)" |
*
* @param {Was_CompareInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const was_compare = /** @type {((inputs?: Was_CompareInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Was_CompareInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_was_compare(inputs)
	if (locale === "es") return es_was_compare(inputs)
	if (locale === "fr") return fr_was_compare(inputs)
	if (locale === "de") return de_was_compare(inputs)
	if (locale === "ja") return ja_was_compare(inputs)
	if (locale === "zh") return zh_was_compare(inputs)
	if (locale === "ar") return ar_was_compare(inputs)
	if (locale === "id") return id_was_compare(inputs)
	if (locale === "it") return it_was_compare(inputs)
	if (locale === "ru") return ru_was_compare(inputs)
	if (locale === "pt") return pt_was_compare(inputs)
	return ko_was_compare(inputs)
});